import React, { Component } from 'react';
import userfill from "../images/lokal/avatar-fill.png"
import Login from "../headerComponents/login"
import Signup from "../headerComponents/signup"
import Userdrop from "../headerComponents/userdropdown"
import userLoginImg from "../fragrance/images/user.png"
import whiteUserIcon from "../images/icons/whiteUserIcon.png"
import $ from "jquery";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faUser, faUserAlt } from '@fortawesome/free-solid-svg-icons'
import User from "../images/Maevelifestyle/profile-user.png"
import UserLuna from "../images/lokal/user-h.png"
import UserImg from "../images/lokal/header-user.png";
export default class HeaderLogin extends Component {
  constructor(props) {
    super(props)
    this.state = {
      userdropVisible: false
    };
  }
  userdropClick() {
    if ($('#userdropdown').is(':visible')) {
      $('#userdropdown').hide();
    }
    else {
      $('#userdropdown').show();
    }
  }
  componentDidMount() {
    $(document).mouseup(function (e) {
      var menuContainer = $(".userdropdown");
      var headerIcons = $(".headerIcons");
      if (!menuContainer.is(e.target) && menuContainer.has(e.target).length === 0 && !headerIcons.is(e.target) && headerIcons.has(e.target).length === 0) {
        menuContainer.hide();
      }
    });
  }
  loginClick() {
    $(".loginPopUp").show();
    $(".loginForgotHide").show();
    $("#username").focus();
    $("#username").show();
    $("#password").hide();
    $("#btnSubmit").show();
    $("#btnLogin").hide();
    $("#otp").hide();
    $(".loginErrorMsg").text('');
    $("#resendOTP").hide();
    $("#btnOTPLogin").hide();
  }
  render() {
    let userId = localStorage.getItem('userId');
    let themeId = localStorage.getItem('themeId')
    return (
      <div className="headerIcons">
        {(() => {
          if (themeId === '36' || themeId === '35') {
            return (
              userId ? <span className="headerImage" onClick={() => this.userdropClick()} ref={userNode => { this.userNode = userNode; }}><FontAwesomeIcon icon={faUser} /></span>
                : <span className="headerImage" title="User" onClick={this.loginClick}>Login<FontAwesomeIcon icon={faAngleDown} /></span>
            )
          }
          else if (themeId === '34' ) {
            return (
              userId ? <span className="headerImage" onClick={() => this.userdropClick()} ref={userNode => { this.userNode = userNode; }}><img src={userfill} alt="" /></span>
                : ""
            )
          }
          else if (themeId === '29') {
            return (
              userId ? <span className="headerImage" onClick={() => this.userdropClick()} ref={userNode => { this.userNode = userNode; }}><img src={whiteUserIcon} alt="" /></span>
                : ""
            )
          }
             else if (themeId === '30') {
            return (
              userId ? <span className="headerImage" onClick={() => this.userdropClick()} ref={userNode => { this.userNode = userNode; }}><img src={userLoginImg} alt="" /></span>
                : <span className="headerImage" title="User" onClick={this.loginClick}><img src={userLoginImg} alt="" /></span>
            )
          }
          else if (themeId === '2' || themeId === '4') {
            return (
              userId ? <span className="headerImage" onClick={() => this.userdropClick()} ref={userNode => { this.userNode = userNode; }}>
                {/* <FontAwesomeIcon icon={faUser} /> */}
                <img src={themeId === '4' ? UserLuna : User} alt="User" className='img-fluid mr-4 cursor-pointer' width="32" height="32"/>
                </span>
                : <span className="headerImage" title="User" onClick={this.loginClick}><img src={themeId === '4' ? UserLuna : User} alt="User" className='img-fluid mr-4 cursor-pointer' width="32" height="32"/></span>
            )
          }
          else {
            return (
              userId ? <span className="headerImage" onClick={() => this.userdropClick()} ref={userNode => { this.userNode = userNode; }}><FontAwesomeIcon icon={faUser} /></span>
                : <span className="headerImage" title="User" onClick={this.loginClick}><FontAwesomeIcon icon={faUserAlt} /></span>
            )
          }
        })()}
        <div className="popupWrap loginPopUp">
          <Login></Login>
        </div>
        <div className="popupWrap signUpPopUp">
          <Signup></Signup>
        </div>
        <Userdrop></Userdrop>
      </div>
    )
  }
}